<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M19.5 21.5V3H4.5V21.5M19.5 21.5H22.5M19.5 21.5H14V16.5H10V21.5H7.25H4.5M4.5 21.5H1.5" stroke="#000" stroke-width="1.5"/>
</svg>
